class Source {
  constructor() {
    this.embeddable = true
    this.inputs = {
      MAIN: "256",
      VOD: "256",
      HLS: "256",
      MULTICAST: "256",
      RF: "256",

      HDMI1: "0",
      HDMI2: "1",
      HDMI3: "2",
      DVBT: "3",
      DVBC: "4",
      DVBS: "5",
      ATV: "10"
    }
  }
  async _init() {
    return true
  }

  async get() {
    if (__.platform.focus) return "256"

    let promise = await _$.progress.create()
    promise.terminateAfter(3000)

    _$.vue.$once(["getCurrentSourceSystemMessage"], res => promise.resolve(res))
    playmore.device.getSource()

    let source = await promise.done
    source = source.replace("_", "").replace("HDMI4", "HDMI2")
    source = this.inputs[source]

    return source
  }
  async set(source) {
    if (source == "256") {
      playmore.platform.returnToPlatform()
      _$.handler.emit("source_event", 256)
      return true
    }

    let promise = await _$.progress.create()
    promise.terminateAfter(3000)

    _$.vue.$once(["setSwitchSourceSystemMessage"], res => (res === "OK" ? promise.resolve() : promise.reject()))

    playmore.device.setSource(parseInt(source))
    const res = await promise.done
    if (res) _$.handler.emit("source_event", source)
    return true
  }
}

export default Source
